import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { Button } from '@cordata/buffet';

import usePatient from '~/utils/patient/hook';

const ServiceReferralConfirmation = ({
  emailHref,
  isOpen,
  toggleIsOpen,
}) => {
  const [,, actions] = usePatient();

  return (
    <Modal isOpen={isOpen} toggle={toggleIsOpen}>
      <ModalHeader toggle={toggleIsOpen}>Are you sure?</ModalHeader>

      <ModalBody>
        An email will be generated with sensitive information.
        Please make sure to encrypt with your institution&#39;s
        encryption method.
      </ModalBody>

      <ModalFooter className="d-flex">
        <div className="ml-auto">
          <Button
            type="cancel"
            onClick={toggleIsOpen}
          >
            Cancel the email
          </Button>

          <Button
            type="link"
            tag="a"
            href={emailHref}
            onClick={() => {
              actions.audit('SendServiceReferralEmail');
              toggleIsOpen();
            }}
          >
            Yes, generate the email
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

ServiceReferralConfirmation.propTypes = {
  emailHref: PropTypes.func.isRequired,
  isOpen: PropTypes.func.isRequired,
  toggleIsOpen: PropTypes.func.isRequired,
};

export default ServiceReferralConfirmation;
